var H = /* @__PURE__ */ ((r) => (r.THIN = "2 2 5 0", r.NORMAL = "2 3 6 0", r.THICK = "2 5 5 0", r))(H || {});
export {
  H as StrokeType
};
